// extracted by mini-css-extract-plugin
export default {"flavor_option":"XY","out_of_stock_text":"YY","out_of_stock":"ZY","flavor_option_image":"aZ","flavor_option_info":"bZ","flavor_option_title":"cZ","flavor_option_limited":"eZ","flavor_option_amount_wrapper":"fZ","flavor_option_amount_button":"gZ","zero_amount":"hZ","no_flavors":"iZ","no_flavors_active":"jZ","flavor_option_select_wrapper":"kZ","flavor_option_select_wrapper__selected":"lZ"};
    if(module.hot) {
      // 1715276859772
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  